<template>
  <div>
    <template v-if="!hideYesterday">
      <div>
        <p>
          за <strong>{{ moment(balance.start_date, "DD.MM.YYYY") }}</strong>
        </p>
        <template v-for="(bal, curr) in balance.start" v-if="bal.orders">
          <p>{{ $AllCurrencies[curr].currency }}:
            <strong>{{ (bal.orders - (+curr === 33 ? totalNoCashStart : 0)).toLocaleString("ru-RU") }}</strong>
            <span
              v-if="currentCurrencyId !== 33"> (RUB: {{
                getCalculatedAmount((balance.start[currentCurrencyId]?.orders ?? 0)).toLocaleString("ru-RU")
              }})</span>
          </p>
        </template>
      </div>
      <hr/>
    </template>
    <p>
      за <strong>{{ moment(currentDate, "DD.MM.YYYY") }}</strong>
    </p>


    <div v-for="(currencyId, i) in reportCurrencies" :key="currencyId">
      <p v-if="reportCurrencies.length > 1"><strong>{{ $AllCurrencies[currencyId]?.currency }}</strong></p>

      <!--      <CurrencyCalculation-->
      <!--        :currencyId="currencyId"-->
      <!--        :currentCurrencyId="currentCurrencyId"-->
      <!--        :incomes="incomes"-->
      <!--        :expenses="expenses"-->
      <!--        :balance="balance"/>-->

      <p>
        Сальдо прошлого дня::
        <strong>{{
            currentCurrencyId === +currencyId ? ((balance.start[currentCurrencyId]?.orders ?? 0) - totalNoCashStart).toLocaleString("ru-RU") :
              getCalculatedAmount((balance.start[currentCurrencyId]?.orders ?? 0) - totalNoCashStart).toLocaleString("ru-RU")
          }}</strong>
      </p>
      <template v-if="expenses && expenses.length">
        <div class="flex">
          <p>
            Расходы:
            <strong>{{
                getTotalAmount("expenses", currencyId).toLocaleString("ru-RU")
              }}</strong>
          </p>
          <v-popover
            class="d-inline"
            placement="bottom"
            :auto-hide="true"
            trigger="manual"
            :open="detailedExpenses"
          >
            <i
              @click="detailedExpenses = !detailedExpenses"
              class="p-l-5 icon-fa icon-fa-info-circle expenses_tooltip_fa"
            ></i>
            <template slot="popover">
              <p v-for="exps in expenses">
                {{ $AllCurrencies[exps.currency_id].currency }}:
                <strong>{{ exps.sum.toLocaleString("ru-RU") }}</strong>
                <span v-if="exps.comment">({{ exps.comment }})</span>
              </p>
            </template>
          </v-popover>
        </div>
      </template>
      <div v-if="incomes && incomes.length">
        <template v-if="getIncomes('income', true)">
          <div class="flex">
            <p>
              Входящие инкассации:
              <strong>{{
                  getIncomes("income", false, true, +currencyId).toLocaleString("ru-RU")
                }}</strong>
            </p>
            <v-popover
              class="d-inline"
              placement="bottom"
              :auto-hide="true"
              trigger="manual"
              :open="detailedIncomesIn"
            >
              <i
                @click="detailedIncomesIn = !detailedIncomesIn"
                class="p-l-5 icon-fa icon-fa-info-circle expenses_tooltip_fa"
              ></i>
              <template slot="popover">
                <p v-for="exps in getIncomes('income')">
                  {{ $AllCurrencies[exps.currency_id].currency }}:
                  <strong>{{ exps.sum.toLocaleString("ru-RU") }}</strong>
                  <span v-if="exps.comment">({{ exps.comment }})</span>
                </p>
              </template>
            </v-popover>
          </div>
        </template>
        <template v-if="getIncomes('outCome', true)">
          <div class="flex">
            <p>
              Исходящие инкассации:
              <strong>{{
                  getIncomes("outCome", false, true, +currencyId).toLocaleString("ru-RU")
                }}</strong>
            </p>
            <v-popover
              class="d-inline"
              placement="bottom"
              :auto-hide="true"
              trigger="manual"
              :open="detailedIncomesOut"
            >
              <i
                @click="detailedIncomesOut = !detailedIncomesOut"
                class="p-l-5 icon-fa icon-fa-info-circle expenses_tooltip_fa"
              ></i>
              <template slot="popover">
                <p v-for="exps in getIncomes('outCome', false, false, +currencyId)">
                  {{ $AllCurrencies[exps.currency_id].currency }}:
                  <strong>{{ exps.sum.toLocaleString("ru-RU") }}</strong>
                  <span v-if="exps.comment">({{ exps.comment }})</span>
                </p>
              </template>
            </v-popover>
          </div>
        </template>
      </div>
      <template v-if="cardsCashOut">
        <p>Обналичивание доставочных карт:
          <strong>{{ cardsCashOut.toLocaleString('ru-RU') }}</strong></p>
      </template>
      <p v-if="exchanges.length">
        Покупка валюты: <strong>{{ totalFigures.exchanges.toLocaleString('ru-RU') }}</strong>
      </p>
      <p v-if="orders?.total_pass ?? 0">
        Сумма по сегодняшним заявкам (с вычетом зарплаты):
        <strong>{{
            (+currencyId !== 33 ? (orders.total_currency_clear_price ?? 0) : (orders?.total_pass ?? 0)).toLocaleString("ru-RU")
          }}</strong>
        <template v-if="totalNoCashEnd">
        <span> - <strong>{{
            totalNoCashEnd.toLocaleString("ru-RU")
          }}</strong> <span class="underline">(расчет по без.нал.) = <strong>{{
            ((orders?.total_pass ?? 0) - totalNoCashEnd).toLocaleString("ru-RU")
          }}</strong></span></span>
        </template>
      </p>
      <p>
        ИТОГО:
        <strong
        >{{
            (currentCurrencyId === +currencyId ? ((balance.start[currentCurrencyId]?.orders ?? 0) - totalNoCashStart) : getCalculatedAmount((balance.start[currentCurrencyId]?.orders ?? 0) - totalNoCashStart)).toLocaleString("ru-RU")
          }} -
          {{ getTotalAmount("expenses", currencyId).toLocaleString("ru-RU") }} -
          <!--          {{ totalFigures.incomesOut.toLocaleString("ru-RU")  }} +-->
          {{ getIncomes("outCome", false, true, +currencyId).toLocaleString("ru-RU") }} +
<!--          {{ totalFigures.incomesIn.toLocaleString("ru-RU") }} +-->
          {{ getIncomes("income", false, true, +currencyId).toLocaleString("ru-RU") }} +
          {{ cardsCashOut.toLocaleString("ru-RU") }} +
          {{
            (+currencyId !== 33 ? ((orders?.total_currency_clear_price ?? 0) - totalNoCashEnd) : ((orders?.total_pass ?? 0) - totalNoCashEnd)).toLocaleString("ru-RU")
          }} -
          {{ totalFigures.exchanges.toLocaleString("ru-RU") }}
        </strong>
        =
        <strong>{{ getTotalDayOffSum(currencyId).toLocaleString("ru-RU") }}</strong>
      </p>
      <hr>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CurrencyCalculation from "@/views/reports/components/saldo/CurrencyCalculation.vue";

export default {
  components: {CurrencyCalculation},
  props: ["balance", "expenses", "orders", "incomes", "exchanges", "division", 'hideYesterday'],
  data() {
    return {
      currentCurrencyId: 33,
      reportCurrencies: [33],
      currentDate: null,
      detailedExpenses: false,
      detailedIncomesOut: false,
      detailedIncomesIn: false,
      totalNoCashStart: 0,
      totalNoCashEnd: 0,
      cardsCashOut: 0,
      totalFigures: {
        expenses: 0,
        incomes: 0,
        incomesIn: 0,
        incomesOut: 0,
        exchanges: 0
      }
    };
  },
  created() {
    this.currentCurrencyId = this.$AllDivisions[this.division]?.settings?.currency_id ?? this.currentCurrencyId;
    if (this.currentCurrencyId !== 33) {
      this.reportCurrencies.push(this.currentCurrencyId);
    }
    this.currentDate = moment(this.balance.start_date)
      .add(1, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    // this.totalFigures.expenses = this.expenses ? this.expenses.reduce((acc, e) => e.currency_id === 33 ? acc += e.sum : acc, 0) : 0;
    this.updateExchangesAmount();
    // this.totalNoCashStart = this.balance.cards && this.balance.cards.start && this.balance.cards.start.totalSum || 0;
    // this.totalNoCashEnd = this.balance.cards && this.balance.cards.end && this.balance.cards.end.totalSum || 0;
    this.totalNoCashStart = this.balance?.cards?.start?.currentDivision?.totalSum || 0;
    this.totalNoCashEnd = this.orders?.no_cash_total || 0;
    this.cardsCashOut = this.balance.cards && this.balance.cards.end && this.balance.cards.end.cardsCashOut && this.balance.cards.end.cardsCashOut.sum || 0;
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    }
  },
  methods: {
    getCalculatedAmount(amount) {
      let rate = 1
      switch (+this.currentCurrencyId) {
        case 40:
          rate = this.$AllCurrencies[41]?.rate ?? 1;
          break;
      }
      return Math.round(amount / rate * 1000) / 1000;
    },
    getTotalDayOffSum(currencyId = 33) {
      const sum = (currencyId === 33 ? this.getCalculatedAmount(this.balance.start[this.currentCurrencyId]?.orders ?? 0) : this.balance.start[this.currentCurrencyId]?.orders ?? 0) -
        this.totalNoCashStart +
        (currencyId !== 33 ? (this.orders.total_currency_clear_price ?? 0) : this.orders?.total_pass ?? 0) -
        this.totalNoCashEnd +
        this.cardsCashOut +
        // this.totalFigures.incomesIn -
        this.getIncomes("income", false, true, +currencyId) -
        // this.totalFigures.incomesOut -
        this.getIncomes("outCome", false, true, +currencyId) -
        this.totalFigures.incomesOut -
        +this.getTotalAmount("expenses", currencyId) -
        // this.totalFigures.expenses -
        this.totalFigures.exchanges;
      this.$set(this.balance, 'dayOffSum', sum);
      return sum;
    },
    updateExchangesAmount() {
      let sum = 0;
      this.exchanges.forEach(e => {
        // console.log("---", e, e.total, e.id);
        if (!e.total) {
          sum += (+Math.round(e.sum / e.rate));
        } else {
          sum += +e.total;
        }
      });
      this.totalFigures.exchanges = sum;
    },
    getIncomes(title, count = false, total = false, currencyId = 33) {
      let arr = [];
      let sum = 0;
      // console.log(title, total, currencyId, this.incomes, this.$currentUID)
      [...this.incomes].forEach(i => {
        if (title === "income") {
          if ((i.type_id === 1 && i.to_division_id === +this.division) || (i.type_id === 5 && i.to_user_id === this.$currentUID)) {
            if (total) {
              if (i.currency_id !== +currencyId) {
                sum += Math.round(this.getSumByCurrency(i.sum, i.currency_id));
              } else {
                sum += i.sum;
              }
            }
            arr.push(i);
          }
        } else {
          if ((i.type_id === 1 && i.to_division_id !== +this.division) || (i.type_id === 5 && i.user_id === this.$currentUID)) {
            if (total) {
              if (i.currency_id !== +currencyId) {
                sum += Math.round(this.getSumByCurrency(i.sum, i.currency_id));
              } else {
                sum += i.sum;
              }
            }
            arr.push(i);
          }
        }
      });
      // console.log(sum);
      if (total) {
        if (title === "income") {
          // this.totalFigures.incomesIn = sum;
        } else {
          //   this.totalFigures.incomesOut = sum;
        }
        return sum;
      }
      return count ? arr.length : arr;
    },
    moment: function (date, format) {
      if (!date) return;
      return moment(date).format(format);
    },
    getTotalAmount(title, currencyId = null) {
      let total = 0;
      switch (title) {
        case "incomes":
          this.incomes.forEach(i => {
            if (i.currency_id === 33) {
              total += i.division_id == this.division ? i.sum : i.sum * -1;
            }
          });
          break;
        case "expenses":
          this.expenses.forEach(i => {
            if (+currencyId === i.currency_id) {
              total += i.sum;
            } else {
              if (+currencyId === 33) {
                if (i.currency_id === 40) {
                  total += Math.round(i.sum / this.$AllCurrencies[41].rate * 10) / 10;
                }
              }
            }
            // if (i.currency_id === 33) {
            //   total += i.sum;
            // }
          });
          break;
      }
      // this.totalFigures[title] = total;
      return total;
    }
  }
};
</script>

<style scoped>
p {
  margin-bottom: 2px;
}

.expenses_tooltip_fa {
  font-size: 20px;
  color: #5bbfde;
  cursor: pointer;
}
</style>

<style>
.tooltip.popover .popover-inner {
  background: white;
  color: #333;
  padding: 15px;
  text-align: left;
}

.tooltip-inner {
  max-width: 370px;
}

.tooltip {
  //max-width: 370px; width: max-content;
}

.popover-inner p {
  margin-bottom: 3px;
}

.popover-inner label {
  font-weight: 600;
}

.underline {
  text-decoration: underline;
}
</style>
